// extracted by mini-css-extract-plugin
export var fullWidthButton = "_oe-0";